export enum ExperimentTypeEnum {
    Unknown,
    User,
    Site
}